import { useState, useEffect } from 'react';
import QRCode from 'qrcode.react';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import NextImage from '@/components/NextImage';
import { Icon360 } from '@/components/UI/svg/Wave2';
import Model3D from '@/components/Model3D';

const sceneList = [
    {
        name: 'detail.sectionP_6',
        video: 'section_g.jpg',
    },
    {
        name: 'detail.sectionP_4',
        video: 'section_g.jpg',
    },
];

const temp_unit: any = {
    us: 'f',
    ca: 'c',
    cn: 'c',
    za: 'c',
    au: 'c',
    de: 'c',
    fr: 'c',
    it: 'c',
    es: 'c',
    uk: 'c',
};

export default function P() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('wave2portableairconditioner');
    const { locale } = useRouter();
    const [active, setActive] = useState(0);
    const [active1, setActive1] = useState(0);
    const [qrcodeUrl, setQRCodeUrl] = useState<string>('');
    const [modelUrl, setModelUrl] = useState<string[]>(['', '']);

    const onChangeScene = (index: number) => setActive(index);
    const onChangeScene1 = (index: number) => {
        setActive1(index);
        if (index === 0) {
            setQRCodeUrl(`${window?.origin}/${locale}/ar?glb=${modelUrl[0]}&redirect=/${locale}/wave-2-portable-air-conditioner`);
        } else {
            setQRCodeUrl(`${window?.origin}/${locale}/ar?glb=${modelUrl[1]}&redirect=/${locale}/wave-2-portable-air-conditioner`);
        }
    };

    useEffect(() => {
        AniContainer.create({
            syncFromTo: [['.wave2-detail-O .viewport-wrapper', { opacity: 0 }, { opacity: 1 }]],
            triggerElement: '.wave2-detail-O .viewport-wrapper',
            triggerHook: 1,
            offset: '10%',
            duration: '20%',
        });
        setQRCodeUrl(`${window?.origin}/${locale}/ar?glb=${modelUrl[0]}&redirect=/${locale}/wave-2-portable-air-conditioner`);

        AniContainer.create({
            syncFromTo: [[`.${css.wave2DetailP} .viewport-wrapper`, { opacity: 0 }, { opacity: 1 }]],
            triggerElement: `.${css.wave2DetailP} .viewport-wrapper`,
            triggerHook: 1,
            offset: '10%',
            duration: '20%',
            onLazyLoad: async () => {
                setModelUrl([
                    `/models/wave2/wave2_${temp_unit[locale] || temp_unit.ca}.glb`,
                    `/models/wave2/wave2_battery_${temp_unit[locale] || temp_unit.ca}.glb`,
                ]);
            },
        });
    }, []);

    return (
        <div className={`wave2-detail-P ${css.wave2DetailP}`}>
            <div className="viewport-wrapper">
                <p className="title">{t('detail.sectionP_title')}</p>
                <div className="s360-wrapper">
                    <div className="left">
                        <div className="title">
                            <Icon360 />
                            <p className="text">{t('detail.sectionP_2')}</p>
                        </div>
                        <div className={`model-3d-1 ${active === 0 ? 'active' : ''}`}>
                            <Model3D props={{ style: { width: '100%', height: '100%' }, loading: 'lazy', src: modelUrl[0] }} />
                        </div>
                        <div className={`model-3d-2 ${active === 1 ? 'active' : ''}`}>
                            <Model3D props={{ style: { width: '100%', height: '100%' }, loading: 'lazy', src: modelUrl[1] }} />
                        </div>
                        <div className="scene-list">
                            {sceneList.map((item, i) => (
                                <p className={`text ${active === i ? 'active' : ''}`} key={i} onClick={() => onChangeScene(i)}>
                                    {t(item.name)}
                                </p>
                            ))}
                        </div>
                    </div>
                    <div className="right">
                        <NextImage
                            webpSrc={require('@publicLocal/wave2/detail/pc/section_p.webp')}
                            src={require('@publicLocal/wave2/detail/pc/section_p.png')}
                            alt={t('detail.sectionP_title')}
                            aria-label={t('detail.sectionP_title')}
                        />
                        <p className="title">{t('detail.sectionP_3')}</p>
                    </div>
                </div>
                {['eu', 'uk', 'de', 'fr', 'it', 'es', 'ph'].includes(locale) && <p className="memo">{t('detail.secP_memo')}</p>}
                <div className="ar-wrapper">
                    <div className="qr-code">
                        <QRCode value={qrcodeUrl} renderAs="canvas" size={100} />
                    </div>
                    <p className="title">{t('detail.sectionP_5')}</p>
                    <p className="desc">{t('detail.only_apple_support')}</p>
                    <div className="scene-list">
                        {sceneList.map((item, i) => (
                            <p className={`text ${active1 === i ? 'active' : ''}`} key={i} onClick={() => onChangeScene1(i)}>
                                {t(item.name)}
                            </p>
                        ))}
                    </div>
                    <NextImage
                        webpSrc={require(`@publicLocal/wave2/detail/pc/section_p_ar${active1}.webp`)}
                        src={require(`@publicLocal/wave2/detail/pc/section_p_ar${active1}.png`)}
                        alt={t('detail.sectionP_title')}
                        aria-label={t('detail.sectionP_title')}
                    />
                </div>
            </div>
        </div>
    );
}
